var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.927246H513V342.894H0V0.927246Z",
    fill: "#41662E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 0.927246H513V342.894H256.5V0.927246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.167 106.433L312.71 146.912L265.117 131.482L294.574 171.961L265.117 212.44L312.71 197.01L342.167 237.488V187.391L389.76 171.861L342.167 156.43V106.433Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.505 278.168C251.891 278.168 204.298 230.575 204.298 171.961C204.298 113.346 251.891 65.7537 310.505 65.7537C328.841 65.7537 345.974 70.3627 361.004 78.4785C337.458 55.4335 305.195 41.2058 269.626 41.2058C197.485 41.2058 138.971 99.7199 138.971 171.861C138.971 244.001 197.485 302.515 269.626 302.515C305.195 302.515 337.458 288.287 361.004 265.243C346.075 273.459 328.841 278.168 310.505 278.168Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 341.967,
    fill: "white",
    transform: "translate(0 0.927246)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDz);
export default __webpack_public_path__ + "static/media/DZ.e3a17d7c66477ff4c40200a8142277a1.svg";
export { ForwardRef as ReactComponent };